import { Box, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import * as api from "api/Core";
import { AppImages } from "assets/appResources";
import { GlobalClassKeys } from "assets/jss/common-styles";
import { RequestIndicator } from "components/CallServer";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiDialogTitleClose from "components/MuiExtras/MuiDialogTitleClose";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { AccessKeys } from "Constants";
import { AboutInfoDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { RoutePaths } from "routes/RouteConfig";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: AboutInfoDto;
    loading: boolean;
    lastError: any;
}

interface IProps {
    onClose: () => void;
};

type Props = IProps & RouteComponentProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class AboutDialog extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
            lastError: null
        };
    }

    private load() {

        api.getAboutInfo()
            .then((result) => {
                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false, lastError: error });
            });
    }

    /////////////////////////////////////////////////////////////////////////////////////

    componentDidMount() {
        this.load();
    }

    render() {
        const { loading, lastError, data } = this.state;
        return (
            <Dialog
                open
                fullWidth
                onBackdropClick={() => { this.props.onClose(); }}
                onClose={() => { this.props.onClose(); }}
                maxWidth="sm"
                role="dialog"
            >

                <MuiDialogTitleClose onClose={() => this.props.onClose()}>
                </MuiDialogTitleClose>


                <DialogContent>

                    <MuiPaper dense fullHeight elevation={0}>

                        {
                            loading
                                ? <RequestIndicator type="waiting" />
                                : (
                                    <div>
                                        <GridEx container fullHeight justifyContent="center" alignItems="flex-start">

                                            <GridEx item >
                                                <img src={AppImages.TheGenieRight} alt="Genie Logo" height={250} />
                                            </GridEx>

                                            <GridEx item xs>
                                                {
                                                    lastError
                                                        ? <RequestErrorReport error={lastError} />
                                                        : (
                                                            <div className={GlobalClassKeys.textCenter}>

                                                                <Typography variant="h4">{data.product}</Typography>
                                                                <Typography variant="h5">{data.company}</Typography>
                                                                <Typography variant="h5">&copy;{data.copyright}</Typography>

                                                                <br />
                                                                <br />

                                                                <Typography variant="body2">API {data.version}</Typography>
                                                                <br />
                                                                <Typography variant="body2">{this.props.t("Views.Public.ReleaseNotes.CurrentAppRelease")} <Link to={RoutePaths.ReleaseNotes}>{Session.appVersion}</Link></Typography>
                                                            </div>
                                                        )
                                                }
                                            </GridEx>
                                        </GridEx>

                                        <Box mt={2}>
                                            <Typography variant="body2">{this.props.t("Common.Literals.KeyboardShortcuts")}</Typography>
                                            <ul>
                                                <li>ALT+{AccessKeys.FeedFirstCard} : {this.props.t("Common.AccessKeys.FeedFirstCard")}</li>
                                                <li>ALT+{AccessKeys.FeedStartup} : {this.props.t("Common.AccessKeys.FeedStartup")}</li>
                                                <li>ALT+{AccessKeys.Search} : {this.props.t("Common.AccessKeys.Search")}</li>
                                                <li>ALT+{AccessKeys.ReloadFeed} : {this.props.t("Common.AccessKeys.ReloadFeed")}</li>
                                                <li>ALT+{AccessKeys.AutoComplete} : {this.props.t("Common.AccessKeys.AutoComplete")}</li>
                                                <li>ALT+{AccessKeys.CreateContent} : {this.props.t("Common.AccessKeys.CreateContent")}</li>
                                                <li>ALT+{AccessKeys.Notification} : {this.props.t("Common.AccessKeys.Notification")}</li>
                                                <li>ALT+{AccessKeys.UserMenu} : {this.props.t("Common.AccessKeys.UserMenu")}</li>
                                            </ul>
                                        </Box>
                                    </div>
                                )
                        }

                    </MuiPaper>
                </DialogContent>
                <DialogActions />
            </Dialog>
        );
    }
}

export default withRouter(withTranslation()(AboutDialog));
